var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "rtl-flip-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.522 95.564c-4.174 4.174-6.522 9.826-6.522 15.739v384.349c6.522-3.739 14.174-5.913 22.261-5.913h22.261v-356.175h934.956v756.87h-356.172v22.261c0 8.086-2.173 15.741-5.913 22.261h384.347c5.914 0 11.568-2.348 15.741-6.52s6.52-9.826 6.52-15.741v-801.392c0-5.913-2.348-11.565-6.52-15.739s-9.826-6.522-15.741-6.522h-979.479c-5.913 0-11.565 2.348-15.739 6.522zM737.307 211.39c-4.004 6.956-4.004 15.478 0 22.434 4.088 6.957 11.568 11.131 19.562 11.044h79.826l-229.128 229.131c-5.826 5.565-8.173 13.913-6.087 21.652 2 7.826 8.087 13.913 15.913 15.913 7.74 2.088 16.087-0.261 21.653-6.087l229.131-229.131v79.826c-0.084 8 4.088 15.478 11.046 19.565 6.951 4.001 15.473 4.001 22.431 0 6.957-4.087 11.131-11.565 11.046-19.565v-155.826h-155.832c-7.994-0.088-15.473 4.087-19.562 11.043zM22.261 534.261h534.262c12.261 0 22.261 10 22.261 22.261v356.174c0 12.258-10 22.261-22.261 22.261h-534.262c-12.261 0-22.261-10.003-22.261-22.261v-356.174c0-12.261 10-22.261 22.261-22.261zM534.262 578.783h-489.74v311.651h489.74v-311.651z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.e6e2706b6232be6695c780e2d68219e3.svg";
export { ForwardRef as ReactComponent };